import EmployeeCard from './employeeCard';
export default EmployeeCard;